import { __decorate, __metadata } from "tslib";
import { ApiPropertyOptional } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { IsBoolean, IsNumber, IsOptional, ValidateIf } from 'class-validator';
import { StoreExposeGroup } from '../interface';
import { ReadStoreOrderStatusDto } from './ReadStoreOrderStatusDto';
import { ReadStoreOrderStatusUpdateConfigDto } from './ReadStoreOrderStatusUpdateConfigDto';
import { ReadStoreOrderTabsDto } from './ReadStoreOrderTabsDto';
export class ReadStoreOrderDto {
}
__decorate([
    ApiPropertyOptional({ type: () => Boolean, example: true }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ groups: [StoreExposeGroup.PATCH] }),
    IsBoolean({ groups: [StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    __metadata("design:type", Boolean)
], ReadStoreOrderDto.prototype, "isActive", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, example: true }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ groups: [StoreExposeGroup.PATCH] }),
    IsBoolean({ groups: [StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    __metadata("design:type", Boolean)
], ReadStoreOrderDto.prototype, "isEmergencyStop", void 0);
__decorate([
    ApiPropertyOptional({ type: () => ReadStoreOrderStatusDto, isArray: true }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ] }),
    Type(() => ReadStoreOrderStatusDto),
    __metadata("design:type", Array)
], ReadStoreOrderDto.prototype, "statuses", void 0);
__decorate([
    ApiPropertyOptional({ type: () => ReadStoreOrderStatusUpdateConfigDto }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ] }),
    Type(() => ReadStoreOrderStatusUpdateConfigDto),
    __metadata("design:type", ReadStoreOrderStatusUpdateConfigDto)
], ReadStoreOrderDto.prototype, "statusUpdateConfig", void 0);
__decorate([
    ApiPropertyOptional({ type: () => ReadStoreOrderTabsDto, isArray: true }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ] }),
    Type(() => ReadStoreOrderTabsDto),
    __metadata("design:type", Array)
], ReadStoreOrderDto.prototype, "orderTabs", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Number, example: 30, minimum: 0 }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ groups: [StoreExposeGroup.PATCH] }),
    IsNumber({}, { groups: [StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    ValidateIf((object) => object.ETADeliveryMinutes !== undefined, { groups: [StoreExposeGroup.PATCH] }),
    __metadata("design:type", Number)
], ReadStoreOrderDto.prototype, "ETAPreparationMinutes", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Number, example: 30, minimum: 0 }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ groups: [StoreExposeGroup.PATCH] }),
    IsNumber({}, { groups: [StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    ValidateIf((object) => object.ETAPreparationMinutes !== undefined, { groups: [StoreExposeGroup.PATCH] }),
    __metadata("design:type", Number)
], ReadStoreOrderDto.prototype, "ETADeliveryMinutes", void 0);
//# sourceMappingURL=ReadStoreOrderDto.js.map